import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WhatsappAudioComponent } from './whatsapp-audio.component';

const routes: Routes = [{ path: '', component: WhatsappAudioComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WhatsappAudioRoutingModule { }
